export default {
  invalidEmail: "Correo electrónico no válido",
  passwordRequired: "La contraseña es obligatoria",
  invalidLogin:
    "Correo o contraseña incorrectos. Vuelva a intentarlo o use «Ha olvidado la contraseña» para restablecerla.",
  accountDisabled:
    "Esta cuenta está desactivada. Contacte con soporte si necesita ayuda.",
  kioskRevoked:
    "El acceso de este dispositivo ha sido revocado. Pida nuevas credenciales al administrador del establecimiento.",
  softwareIdRequired:
    "Este inicio de sesión requiere un identificador de dispositivo. Use el inicio por código QR del dispositivo del local o contacte con soporte.",
  loginSuccess: "¡Inicio de sesión correcto!",
  partnerPortal: "Portal del vendedor",
  heroTitleLine1: "Gestione su",
  heroTitleLine2: "negocio con facilidad",
  heroSubtitle:
    "El portal dedicado a vendedores para gestionar reservas, actividades e ingresos en un solo lugar.",
  statPartners: "Vendedores activos",
  statBookings: "Reservas/mes",
  welcomeBack: "¡Le damos la bienvenida de nuevo!",
  signInSubtitle: "Inicie sesión en su cuenta para continuar",
  email: "Correo electrónico",
  emailPlaceholder: "nombre@ejemplo.com",
  password: "Contraseña",
  passwordPlaceholder: "••••••••",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",
  showConfirmPassword: "Mostrar confirmación de contraseña",
  hideConfirmPassword: "Ocultar confirmación de contraseña",
  signIn: "Iniciar sesión",
  forgotPasswordLink: "¿Ha olvidado la contraseña?",
  forgotPasswordTitle: "Contraseña olvidada",
  forgotPasswordSubtitle:
    "Introduzca el correo de su cuenta. Si coincide con una cuenta del portal del vendedor, le enviaremos un enlace para restablecerla.",
  forgotPasswordSubmit: "Enviar enlace",
  forgotPasswordSuccessToast:
    "Si la dirección es válida, revise su bandeja de entrada.",
  forgotPasswordCheckEmail:
    "Si la dirección es válida, hemos enviado instrucciones a su correo.",
  forgotPasswordRulesReminder:
    "La nueva contraseña deberá tener al menos {{min}} caracteres e incluir mayúsculas y minúsculas, un número y un carácter especial.",
  setPasswordTitle: "Establezca su contraseña",
  setPasswordChecking: "Comprobando el enlace…",
  setPasswordInvalidLink:
    "Este enlace no es válido o ha caducado. Solicite una nueva invitación al staff o pida un restablecimiento desde el inicio de sesión.",
  setPasswordRequirementsTitle: "Requisitos de la contraseña",
  setPasswordRequirementMinLength: "Al menos {{min}} caracteres",
  setPasswordRequirementMixedCase: "Letras mayúsculas y minúsculas (A–z)",
  setPasswordRequirementDigit: "Al menos un número",
  setPasswordRequirementSpecial: "Al menos un carácter especial (p. ej. ! @ #)",
  setPasswordTooCommonToast:
    "Esta contraseña es demasiado fácil de adivinar. Elige una más fuerte y menos común.",
  setPasswordSubmit: "Guardar contraseña",
  setPasswordSuccessToast: "Contraseña guardada. Ya puede iniciar sesión.",
  setPasswordDone:
    "Contraseña guardada. Puede cerrar esta página e iniciar sesión.",
  newPassword: "Nueva contraseña",
  confirmPassword: "Confirmar contraseña",
  passwordConfirmRequired: "Confirme la contraseña",
  passwordsDoNotMatch: "Las contraseñas no coinciden",
  setPasswordMinLength: "La contraseña debe tener al menos {{min}} caracteres",
  setPasswordMixedCase: "Incluya mayúsculas y minúsculas (A–z)",
  setPasswordRequireDigit: "Incluya al menos un número",
  setPasswordRequireSpecial:
    "Incluya al menos un carácter especial (p. ej. ! @ #)",
  backToLogin: "Volver al inicio de sesión",
  testCredentialsTitle: "Credenciales de prueba",
} as const;
